/**a
 * Created by Bart Decorte
 * Date: 2019-08-20
 * Time: 11:16
 */
import MultiDropzone from '../components/uploads/MultiDropzone';
import DropzoneModal from './DropzoneModal';
import {imageRules} from '../helpers/validation_helper';

export default class AssetImportModal extends DropzoneModal {
  constructor() {
    const rootEl = document.querySelector('#modal-asset');
    const dropzoneEl = rootEl.querySelector('.js-dropzone-wrap');

    let fileRules = {}; // everything
    if (rootEl.dataset.type === 'image') {
      // only supported image formats
      fileRules = imageRules();
    }

    const dropzone = new MultiDropzone(dropzoneEl, {
      fileRules,
    });
    super(rootEl, dropzone);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modals/AssetImportModal.js